import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../../Icons/Icon';

const CustomClearIndicator = ({ innerProps }) => {
  const mergedProps = {
    ...innerProps,
    onMouseDown: (event) => {
      event.stopPropagation();
      if (innerProps.onMouseDown) innerProps.onMouseDown(event);
    },
  };

  return (
    <div {...mergedProps}>
      <Icon name="close_modal" className="w-2.5 h-2.5 text-vamos-black" />
    </div>
  );
};

CustomClearIndicator.propTypes = {
  innerProps: PropTypes.object.isRequired,
};

export default CustomClearIndicator;
